import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { maskName } from '~/utils/common';

import type { TypeDeliveryAgencyCreatedShippingLabel } from '~/types/delivery-agency.types';

const getDeliveryAgencyCreatedShippingLabelsColumnDefs = () => {
  const columnDefs: ColDef<TypeDeliveryAgencyCreatedShippingLabel>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'shippingLabelNumber',
      headerName: '추가 운송장 번호',
      width: 245,
    },
    {
      field: 'outboundCode',
      headerName: '출고번호',
      width: 160,
    },
    {
      field: 'receiverName',
      headerName: '수령자명',
      width: 100,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyCreatedShippingLabel,
        TypeDeliveryAgencyCreatedShippingLabel['receiverName']
      >) => maskName(value) ?? '-',
    },
    {
      field: 'productName',
      headerName: '상품명',
      flex: 1,
      minWidth: 252,
      width: 252,
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyCreatedShippingLabelsColumnDefs;
